<script lang="ts">
	import CareerForm from "@components/CareerForm.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import type { CareerPosition } from "../data/careerPositions.js";

	const {
		swapReversed = false,
		headline,
		formClass,
		headlineClass,
		position,
	}: {
		swapReversed?: boolean;
		headline: Snippet;
		formClass?: string;
		headlineClass?: ClassValue;
		position: CareerPosition;
	} = $props();
</script>

<div
	class={["flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between", swapReversed && "lg:flex-row-reverse"]}
>
	<div class="w-full lg:flex-1">
		<h2 class={headlineClass}>
			{@render headline()}
		</h2>
	</div>

	<div class={["w-full flex-1", formClass]}>
		<CareerForm {position} />
	</div>
</div>
